"use client";

import { useEffect, useRef, useState } from "react";
import { VideoHero } from "./VideoHero";
import Letstalk from "../header/LetsTalk";

export default function Why() {
  const [isOpen, setIsOpen] = useState(false);
  const previewVideoRef = useRef<HTMLVideoElement>(null);
  const dialogVideoRef = useRef<HTMLVideoElement>(null);

  // Close on Escape, and lock page scroll while the popup is open.
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  // Pause the muted background preview while the popup is open (avoids
  // decoding two videos at once), resume it once the popup closes.
  useEffect(() => {
    const preview = previewVideoRef.current;
    if (!preview) return;

    if (isOpen) {
      preview.pause();
    } else {
      preview.play().catch(() => {});
    }
  }, [isOpen]);

  // Autoplay with sound once the popup mounts (allowed here since opening the
  // popup is itself a user-click gesture), pause + reset once it closes.
  useEffect(() => {
    const video = dialogVideoRef.current;
    if (!video) return;

    if (isOpen) {
      video.currentTime = 0;
      video.play().catch(() => {
        // Autoplay can be blocked by the browser; the visible controls
        // let the person press play themselves in that case.
      });
    } else {
      video.pause();
    }
  }, [isOpen]);

  return (
    <div
      className=
        "grid grid-cols-1  gap-10  lg:grid-cols-2 bg-background lg:gap-20 p-4 lg:p-24 2xl:p-32"
    >
        <div >
      {/* Thumbnail / play trigger */}
            <h2 className="text-5xl md:text-7xl   2xl:text-8xl mt-6 lg:mt-0 text-primary font-extrabold uppercase">
          Why <br /> choose Us
        </h2>
        <p className="text-xl md:text-4xl font-semibold mt-6 text-secondary">as Your Web Developement Company Partner</p>
</div>
      {/* Text content */}
      <div className="space-y-8">

        <p className=" max-w-prose text-base w-full  2xl:text-xl leading-relaxed text-neutral-600">
        We believe your digital solution should be more than just a finished website. Our annual subscription provides everything you need to stay online and focused on your business, including website development, secure hosting, maintenance, updates, technical support, and ongoing improvements, all in one simple service.
        
        
        </p>
        <p className=" max-w-prose text-base w-full  2xl:text-xl leading-relaxed text-neutral-600">
        Prefer to own and manage your project independently? We also offer one-time development services. Once your project is delivered, we provide free training to help you use and manage it confidently, along with a guarantee period for additional peace of mind. Whatever option you choose, we are committed to delivering quality work and making sure you are fully satisfied with the result.
        </p>

       
      </div>

    </div>
  );
};

